import React from "react";

import Button from "components/ui/button/Button";
import { usePaywall } from "lib/providers/Paywall";
import { yellow } from "lib/themes/colors";

export default function ExportEntityPaywallButton() {
  const { openPaywallModal } = usePaywall();

  return (
    <Button
      buttonType="secondary"
      icon="paywallStar"
      iconProps={{ color: yellow, size: 21 }}
      onClick={() => openPaywallModal("EXPORTS")}
    >
      Export
    </Button>
  );
}
